const TOKEN_KEY = 'cascade_auth_token';

const URL_TOKEN_PARAMS = ['token', 'access_token', 'jwt'];

export function getStoredAuthToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setStoredAuthToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

/** JWT из query/hash (SMS-сервис редиректит с ?token= после /api/set-auth). */
export function bootstrapAuthFromUrl(): void {
  if (typeof window === 'undefined') return;
  try {
    const url = new URL(window.location.href);
    if (url.searchParams.get('logout') === '1' || url.searchParams.get('logout') === 'true') {
      setStoredAuthToken(null);
      url.searchParams.delete('logout');
      const qs = url.searchParams.toString();
      window.history.replaceState({}, document.title, url.pathname + (qs ? `?${qs}` : '') + url.hash);
      return;
    }
    for (const name of URL_TOKEN_PARAMS) {
      const v = url.searchParams.get(name);
      if (v?.trim()) {
        setStoredAuthToken(v.trim());
        url.searchParams.delete(name);
        const qs = url.searchParams.toString();
        window.history.replaceState({}, document.title, url.pathname + (qs ? `?${qs}` : '') + url.hash);
        return;
      }
    }
    const h = window.location.hash;
    if (h && h.length > 1) {
      const raw = h.startsWith('#') ? h.slice(1) : h;
      const hp = new URLSearchParams(raw);
      for (const name of URL_TOKEN_PARAMS) {
        const v = hp.get(name);
        if (v?.trim()) {
          setStoredAuthToken(v.trim());
          hp.delete(name);
          const rest = hp.toString();
          window.history.replaceState({}, document.title, url.pathname + url.search + (rest ? `#${rest}` : ''));
          return;
        }
      }
    }
  } catch {
    /* ignore */
  }
}

export function clearAuthToken(): void {
  setStoredAuthToken(null);
}

declare global {
  interface Window {
    __SMS_CABINET_URL__?: string;
    __SMS_SIGN_UP_URL__?: string;
    /** Пополнение баланса в SMS-сервисе (например app.sms.by). */
    __SMS_PAYMENTS_CREATE_URL__?: string;
  }
}

const DEFAULT_SMS_SIGN_UP_URL = 'https://sms.by/sign-up';
const DEFAULT_SMS_PAYMENTS_CREATE_URL = 'https://app.sms.by/payments/create';
const DEFAULT_SMS_SUBSCRIBERS_MANAGE_URL = 'https://app.sms.by/subscribers';

export function getSmsCabinetUrl(): string {
  const w = typeof window !== 'undefined' ? window.__SMS_CABINET_URL__ : undefined;
  if (w && String(w).trim()) return String(w).trim();
  const e = process.env.REACT_APP_SMS_CABINET_URL;
  return e && e.trim() ? e.trim() : '';
}

/** Страница списков контактов: `SMS_CABINET_URL` + `/subscribers`, иначе https://app.sms.by/subscribers. */
export function getSmsSubscribersManageUrl(): string {
  const base = getSmsCabinetUrl().replace(/\/$/, '').trim();
  if (base) return `${base}/subscribers`;
  return DEFAULT_SMS_SUBSCRIBERS_MANAGE_URL;
}

/** Ссылка на регистрацию в SMS (runtime-config.js или REACT_APP_SMS_SIGN_UP_URL). */
export function getSmsSignUpUrl(): string {
  const w = typeof window !== 'undefined' ? window.__SMS_SIGN_UP_URL__ : undefined;
  if (w && String(w).trim()) return String(w).trim();
  const e = process.env.REACT_APP_SMS_SIGN_UP_URL;
  if (e && e.trim()) return e.trim();
  return DEFAULT_SMS_SIGN_UP_URL;
}

/** Ссылка «Пополнить баланс» (runtime-config.js: `window.__SMS_PAYMENTS_CREATE_URL__` или REACT_APP_SMS_PAYMENTS_CREATE_URL). */
export function getSmsPaymentsCreateUrl(): string {
  const w = typeof window !== 'undefined' ? window.__SMS_PAYMENTS_CREATE_URL__ : undefined;
  if (w && String(w).trim()) return String(w).trim();
  const e = process.env.REACT_APP_SMS_PAYMENTS_CREATE_URL;
  if (e && e.trim()) return e.trim();
  return DEFAULT_SMS_PAYMENTS_CREATE_URL;
}
